import { Component } from "@angular/core";

@Component({
    templateUrl: "./company-profile-submenu.component.html"
})
export class CompanyProfileSubmenuComponent {

}